module.exports = __webpack_public_path__ + "img/logo-safe-ortho.d5f1087e.png";